export const getFaqList = (locale: 'ja' | 'en'): FaqType[] => {
  switch (locale) {
    case 'en':
      return FaqList_EN
    case 'ja':
    default:
      return FaqList_JA
  }
}

export type FaqType = {
  question: string
  answer: string
}

export const FaqList_JA: FaqType[] = [
  {
    question: 'チェックイン・アウトは何時ですか？',
    answer:
      'チェックインは15：00から、チェックアウトは10：00となります。',
  },
  {
    question: 'お風呂・トイレはありますか？',
    answer:
      '各トレーラーハウス内にトイレとシャワールームがございます。',
  },
  {
    question: '設備はなにがありますか？',
    answer:
      'エアコン、冷蔵庫、電子レンジ、電気ケトル、IHコンロがございます。\n詳細はSTAY MENUをご確認ください。',
  },
  {
    question: 'アメニティはありますか？',
    answer:
      'バスタオル、フェイスタオル、ドライヤー、シャンプー・リンスー、ボディソープ、歯ブラシ、スリッパ、カミソリ、綿棒をご用意しております。\n詳細はSTAY MENUをご確認ください。',
  },
  {
    question: 'パジャマはありますか？',
    answer:
      'ご用意しておりませんので、必要な方はご持参お願いいたします。',
  },
  {
    question: '貸出品は何がありますか？',
    answer:
      'BBQ食材を持ち込みの方にはBBQコンロ貸出いたします。（有料）\nその他、携帯充電器の貸出もございます。',
  },
  {
    question: '飲食の持ち込みはできますか？',
    answer:
      'BBQの食材を含め、飲食の持ち込みは可能です。\n※お客様が保有するBBQグリルなどの機材一式（卓上コンロやバーナーといった火気を伴うキャンプアイテムも含む）は持ち込みできません',
  },
  {
    question: 'インターネットは利用できますか？',
    answer:
      '敷地内のWi-Fiをご利用いただけます。',
  },
  {
    question: '駐車場はありますか？',
    answer:
      '敷地内に駐車場はございます。（8台 ご宿泊のお客様専用含む）\n※トレーラーハウスへの横付けはできません',
  },
  {
    question: 'ペットとの宿泊は可能ですか？',
    answer:
      'ペット同伴の宿泊はできません。\nあらかじめご了承ください。',
  },
  {
    question: '未成年者のみでの宿泊はできますか？',
    answer:
      '15歳未満のお客様のみでのご宿泊はお断りしております。\nまた、15歳以上18歳未満のお客様のみでご宿泊される場合は、親権者様の同意書を宿泊者全員分ご提出いただいております。\n\nなお、当施設が必要と判断した場合には、保護者様へ確認のご連絡をさせていただく場合がございます。\nあらかじめご了承ください。',
  },
  {
    question: '予約なしで利用できますか？',
    answer:
      'お部屋や食事の準備がございますので、必ずご予約をお取りの上、お越しください。',
  },
  {
    question: '花火をすることはできますか？',
    answer:
      '手持ち花火のみ可能です。\n指定の場所で時間は夜の21時まででお願いいたします。',
  },
  {
    question: 'キャンセル料は発生しますか？',
    answer:
      'キャンセル料は、ご予約内容およびキャンセル日程に応じて発生いたします。\n詳細につきましては宿泊約款をご確認ください。',
  },
  {
    question: '喫煙はできますか？',
    answer:
      'トレーラーハウス内は全室完全禁煙となっております。\n喫煙をご希望の方は、屋外の指定場所でのみ喫煙をお願いいたします。',
  },
  {
    question: '近くにコンビニやスーパーはありますか？',
    answer:
      '車で約10分～15分ほどの場所にございます。',
  },
  {
    question: '雨が降ってもBBQはできますか？',
    answer:
      'テラスに屋根がついておりますので可能です。',
  }
]

export const FaqList_EN: FaqType[] = [
  {
    question: 'What are the check-in and check-out times?',
    answer: 'Check-in is available from 3:00 PM, and check-out is by 10:00 AM.',
  },
  {
    question: 'Are there bathroom and toilet facilities?',
    answer: 'Each trailer house is equipped with a private toilet and shower room.',
  },
  {
    question: 'What facilities are available?',
    answer: 'Each trailer cabin is equipped with air conditioning, a refrigerator, microwave, electric kettle, and induction cooktop.\n' +
      'Please refer to the Stay Menu for details.',
  },
  {
    question: 'Are amenities provided?',
    answer: 'We provide bath towels, face towels, a hair dryer, shampoo, conditioner, body soap, toothbrushes, slippers, razors, and cotton swabs.\n' +
      'Please refer to the Stay Menu for details.',
  },
  {
    question: 'Are pajamas provided?',
    answer: 'Pajamas are not provided. Guests who require sleepwear are kindly asked to bring their own.',
  },
  {
    question: 'What items are available for rental?',
    answer: 'Guests who bring their own BBQ ingredients may rent a BBQ grill for an additional fee.\n' +
      'Mobile phone chargers are also available for rental.',
  },
  {
    question: 'Can I bring my own food and drinks?',
    answer: 'Guests are welcome to bring their own food and beverages, including BBQ ingredients.\n' +
      'Please note that personal BBQ grills, tabletop stoves, burners, and any other equipment involving open flames are not permitted on the premises.',
  },
  {
    question: 'Is internet access available?',
    answer: 'Complimentary Wi-Fi is available throughout the property.',
  },
  {
    question: 'Is parking available?',
    answer: 'Free parking is available on-site (8 spaces available, including spots reserved for overnight guests).\n' +
      'Please note that vehicles cannot be parked directly beside the trailer houses.',
  },
  {
    question: 'Are pets allowed?',
    answer: 'Pets are not permitted.\n' +
      'Thank you for your understanding.',
  },
  {
    question: 'Can minors stay without an accompanying adult?',
    answer: 'Guests under the age of 15 may not stay without an accompanying adult.\n' +
      'Guests aged 15 to 17 staying without a parent or legal guardian must submit a parental consent form for each guest.\n' +
      'Please note that we may contact a parent or guardian for confirmation if deemed necessary.',
  },
  {
    question: 'Can I use the facility without a reservation?',
    answer: 'Reservations are required.\n' +
      'As we prepare rooms and meals in advance, please make a reservation before your visit.',
  },
  {
    question: 'Is fireworks use permitted?',
    answer: 'Handheld fireworks are permitted only in designated areas and must be used by 9:00 PM.',
  },
  {
    question: 'Is there a cancellation fee?',
    answer: 'Cancellation charges apply depending on your reservation details and the date of cancellation.\n' +
      'Please refer to our Accommodation Terms and Conditions for details.',
  },
  {
    question: 'Is smoking allowed?',
    answer: 'Smoking is strictly prohibited inside all trailer houses.\n' +
      'Guests who wish to smoke may do so only in designated outdoor smoking areas.',
  },
  {
    question: 'Are there any convenience stores or supermarkets nearby?',
    answer: 'Convenience stores and supermarkets are located approximately 10–15 minutes away by car.',
  },
  {
    question: 'Can I enjoy BBQ even in rainy weather?',
    answer: 'Yes. BBQ is available even in rainy weather, as the patio is covered by a roof.',
  },
]
